// ============================================
// modoAgregarCotizacion.js — Estado GLOBAL del "MODO AGREGAR A COTIZACION"
// ============================================
// MOTOR DE ORIGEN F3.B. Estado independiente del carrito: mientras se eligen
// productos para una cotizacion (en EDITAR), este modo esta activo y las paginas
// (La Tienda / Colecciones / Listas) muestran la barra "Agregando a: [nombre]" y
// OCULTAN el carrito flotante. Vive en storage (sobrevive cambios de tab) + un
// CustomEvent para que las paginas reaccionen al instante.
//
// F3.B NO agrega productos todavia (eso es F3.C/D/E): solo monta el modo + la barra.

import { useState, useEffect } from 'react';
import { storage, STORAGE_KEYS } from './storage';

const EVT = 'beep-modo-agregar-cotizacion';

// Lee el modo actual: { cotizacionId, nombre } | null.
export function leerModoAgregar() {
  const v = storage.get(STORAGE_KEYS.MODO_AGREGAR_COTIZACION);
  if (v && v.cotizacionId != null) return v;
  return null;
}

// Activa el modo para una cotizacion concreta y notifica a las paginas.
// Mejora #4b: sustituirLineaId opcional -> cuando esta, el modo es "SUSTITUIR" (el producto
// elegido REEMPLAZA esa linea via PUT .../sustituir, en vez de apendar). null = modo agregar.
export function activarModoAgregar({ id, nombre, sustituirLineaId = null }) {
  storage.set(STORAGE_KEYS.MODO_AGREGAR_COTIZACION, {
    cotizacionId: id, nombre: nombre || '',
    sustituirLineaId: sustituirLineaId != null ? sustituirLineaId : null,
  });
  try { window.dispatchEvent(new CustomEvent(EVT)); } catch { /* SSR/none */ }
}

// Sale del modo (boton "Listo") y notifica. El carrito vuelve a mostrarse normal.
export function salirModoAgregar() {
  storage.remove(STORAGE_KEYS.MODO_AGREGAR_COTIZACION);
  try { window.dispatchEvent(new CustomEvent(EVT)); } catch { /* SSR/none */ }
}

// Hook reactivo: devuelve el modo actual y se re-renderiza cuando cambia
// (mismo tab via CustomEvent, otros tabs via storage event).
export function useModoAgregar() {
  const [modo, setModo] = useState(leerModoAgregar);
  useEffect(() => {
    const refrescar = () => setModo(leerModoAgregar());
    window.addEventListener(EVT, refrescar);
    window.addEventListener('storage', refrescar);
    return () => {
      window.removeEventListener(EVT, refrescar);
      window.removeEventListener('storage', refrescar);
    };
  }, []);
  return modo;
}
